import { useMemo } from 'react';
import { CustomerResponse } from '../types';
import { createRoadmapDataFromProjects } from '../utils/transform-project-to-tasks-utils';

export function useDemoPresentationData(customerData: CustomerResponse | undefined) {
  const roadmapData = useMemo(
    () =>
      customerData?.top_10_projects?.top_projects
        ? createRoadmapDataFromProjects(customerData.top_10_projects.top_projects)
        : undefined,
    [customerData?.top_10_projects?.top_projects]
  );

  const customerName = customerData?.customer_details?.name || 'Customer';

  return { roadmapData, customerName, customerData };
}
